import { type FC, useCallback } from 'react';

import { OBJECT_TYPE_SEGMENTS } from '@iconik-io/iconik-api/src/types/object_types';
import { useBasePlayerContext } from '@iconik-io/unified-player-ui-react';

import { deleteComment } from '../../../ducks/asset_comments/thunks';
import {
  useAppDispatch,
  useAppSelector,
} from '../../../store/react_redux_typed';
import withContextItems from '../context_items_hoc';
import type {
  ContextItemsHocProps,
  ModalComponentProps,
} from '../modals_manager/types';
import DeleteObjectsModal from './delete_objects';

type Props = ModalComponentProps & ContextItemsHocProps;

const DeleteCommentModal: FC<Props> = (props) => {
  const { store: unifiedPlayerStore } = useBasePlayerContext();
  const dispatch = useAppDispatch();
  const assetId = useAppSelector((state) => state.pages.asset.assetId);
  const deleteEntityByIds = useCallback((ids: string[], entity?: string) => {
    if (!entity) {
      return Promise.resolve();
    }
    return dispatch(deleteComment(entity, ids[0])).then(() => {
      unifiedPlayerStore.segment.annotation.clearPersonalDraftAnnotation();
    });
  }, []);

  return (
    <DeleteObjectsModal
      {...props}
      objectType={OBJECT_TYPE_SEGMENTS}
      entity={assetId}
      deleteEntityByIds={deleteEntityByIds}
    />
  );
};

export default withContextItems(DeleteCommentModal);
